import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const [formDetails, setFormDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails(prev => ({
      ...prev,
      [category]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setButtonText("Sending...");
  
  try {
    const response = await fetch('https://server-personal-portfolio-qiun.onrender.com/api/contact', { // Full URL for testing
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formDetails)
    });

      const result = await response.json();
      
      setButtonText("Send");
      
      if (response.ok) {
        setStatus({ success: true, message: 'Message sent successfully!' });
        setFormDetails({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setStatus({ 
          success: false, 
          message: result.message || 'Failed to send message' 
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus({ 
        success: false, 
        message: 'Network error. Please try again.' 
      });
      setButtonText("Send");
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img 
                  className={isVisible ? "animate__animated animate__zoomIn" : ""} 
                  src={contactImg} 
                  alt="Contact" 
                />
              }
            </TrackVisibility>
          </Col>
          <Col md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get In Touch</h2>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={6} className="px-1">
                        <input 
                          type="text" 
                          value={formDetails.firstName}
                          placeholder="First Name" 
                          onChange={(e) => onFormUpdate('firstName', e.target.value)} 
                          required 
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <input 
                          type="text" 
                          value={formDetails.lastName}
                          placeholder="Last Name" 
                          onChange={(e) => onFormUpdate('lastName', e.target.value)} 
                          required 
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <input 
                          type="email" 
                          value={formDetails.email}
                          placeholder="Email" 
                          onChange={(e) => onFormUpdate('email', e.target.value)} 
                          required 
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <input 
                          type="tel" 
                          value={formDetails.phone}
                          placeholder="Phone" 
                          onChange={(e) => onFormUpdate('phone', e.target.value)}
                        />
                      </Col>
                      <Col className="px-1">
                        <textarea 
                          rows="6" 
                          value={formDetails.message}
                          placeholder="Message" 
                          onChange={(e) => onFormUpdate('message', e.target.value)} 
                          required
                        ></textarea>
                        <button type="submit">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                      {status.message && (
                        <Col>
                          <p className={status.success ? "text-success" : "text-danger"}>
                            {status.message}
                          </p>
                        </Col>
                      )}
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};